const defaultState = {
  success: [],
  errors: [],
  loading: false,
  courseOffer: [],
  unitOffers: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_COURSE_OFFER':
      return {
        ...state,
        courseOffer: action.courseOffer,
      };
    case 'SET_CLONE_COURSE_OFFER':
      return {
        ...state,
        cloneCourseOffer: action.courseOffer,
        cloneUnitOffer: action.unitOffer,
      };
    case 'SET_SUBMIT_SUCCESS':
      return {
        ...state,
        success: action.success,
      };
    case 'SET_SUBMIT_ERRORS':
      return {
        ...state,
        errors: action.errors,
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.loading,
      };

    default:
      return state;
  }
};
